module.exports = __webpack_public_path__ + "images/workshop-icon.svg";